module.exports = __webpack_public_path__ + "images/emoji/arrow_double_down.7f5f83bdc3a5c48ea481.png";